import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import "../../utils.css";
import {
    setSelectedDisplayMode,
    setOrderBy,
    setDisplayEndedInterventions,
    setFilteredAndSortedInterventions,
    searchByInterventionNumber,
} from "../../redux/intervention/interventionActions";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { getCurrentFunctionName } from "../../performanceModeManager";
import CustomizedTextField from "../Input/CustomizedTextField";
import { IconButton, Icon, InputLabel } from "@mui/material";
import { TYPING_TIMEOUT } from "../../constants";
import CustomizedSelect from "../Input/CustomizedSelect";

class InterventionsFilters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchInput: props.interventionsFilters.searchInput,
            searchInputTypingTimeout: null,
        };
    }

    shouldComponentUpdate(nextProps, prevState) {
        let currentModeIdChanged =
            this.props.interventionsFilters.currentModeId !==
            nextProps.interventionsFilters.currentModeId;
        let sortingModeChanged =
            this.props.interventionsFilters.sortingModeId !==
            nextProps.interventionsFilters.sortingModeId;
        let displayEndedInterventionsChanged =
            this.props.interventionsFilters.displayEndedInterventions !==
            nextProps.interventionsFilters.displayEndedInterventions;
        let searchInputChanged =
            this.state.searchInput !== prevState.searchInput;

        return (
            currentModeIdChanged ||
            sortingModeChanged ||
            displayEndedInterventionsChanged ||
            searchInputChanged
        );
    }

    onDisplayModeChange(e) {
        this.props.setSelectedDisplayMode(e.target.value.id, {
            ...this.props.interventionsFilters,
        });
    }

    setDisplayEndedInterventions() {
        this.props.setDisplayEndedInterventions(
            !this.props.interventionsFilters.displayEndedInterventions,
            {
                ...this.props.interventionsFilters,
            }
        );
    }

    onSearchInputChange(e) {
        let searchInput = e.target.value ? e.target.value : null;

        if (this.state.searchInputTypingTimeout) {
            clearTimeout(this.state.searchInputTypingTimeout);
        }

        this.setState({
            searchInput,
            searchInputTypingTimeout: setTimeout(() => {
                this.props.searchByInterventionNumber(searchInput, {
                    ...this.props.interventionsFilters,
                });
            }, TYPING_TIMEOUT),
        });
    }

    clearSearchInput() {
        this.setState({
            searchInput: null,
        });

        this.props.searchByInterventionNumber(null, {
            ...this.props.interventionsFilters,
        });
    }

    onSortingModeChange(e) {
        this.props.setOrderBy(e.target.value.id, {
            ...this.props.interventionsFilters,
        });
    }

    renderSelectValue(value) {
        return (
            <div className="row">
                <ListItemIcon className="col-lg-3 col-md-3 col-sm-3 col-3">
                    {value.icon}
                </ListItemIcon>
                <Typography
                    className="col-lg-9 col-md-9 col-sm-9 col-9"
                    variant="inherit"
                    noWrap
                >
                    {value.label}
                </Typography>
            </div>
        );
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let listTypesElement = this.props.interventionsFilters.modeList.map(
            (lt) => (
                <MenuItem key={lt.id} value={lt} className="row">
                    <ListItemIcon className="col-lg-3 col-md-3 col-sm-3 col-3">
                        {lt.icon}
                    </ListItemIcon>
                    <Typography
                        className="col-lg-9 col-md-9 col-sm-9 col-9"
                        variant="inherit"
                        noWrap
                    >
                        {lt.label}
                    </Typography>
                </MenuItem>
            )
        );

        let sortingModesElement =
            this.props.interventionsFilters.sortingModes.map((sm) => (
                <MenuItem key={sm.id} value={sm}>
                    <ListItemIcon className="col-lg-3 col-md-3 col-sm-3 col-3">
                        {sm.icon}
                    </ListItemIcon>
                    <Typography
                        className="col-lg-9 col-md-9 col-sm-9 col-9"
                        variant="inherit"
                        noWrap
                    >
                        {sm.label}
                    </Typography>
                </MenuItem>
            ));

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <InputLabel id="display-mode-label">
                            {"Mode d'affichage"}
                        </InputLabel>
                        <CustomizedSelect
                            labelId="display-mode-label"
                            id="display-mode"
                            value={
                                this.props.interventionsFilters.modeList[
                                    this.props.interventionsFilters
                                        .currentModeId
                                ]
                            }
                            label="Mode d'affichage"
                            onChange={this.onDisplayModeChange.bind(this)}
                            renderValue={this.renderSelectValue}
                        >
                            {listTypesElement}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <InputLabel id="sortingMode-label">Tri</InputLabel>
                        <CustomizedSelect
                            labelId="sortingMode-label"
                            id="sortingMode"
                            value={
                                this.props.interventionsFilters.sortingModes[
                                    this.props.interventionsFilters
                                        .sortingModeId
                                ]
                            }
                            className="row"
                            label="Tri"
                            onChange={this.onSortingModeChange.bind(this)}
                            renderValue={(lt) => (
                                <div className="row">
                                    <ListItemIcon className="col-lg-3 col-md-3 col-sm-3 col-3">
                                        {lt.icon}
                                    </ListItemIcon>
                                    <Typography
                                        className="col-lg-9 col-md-9 col-sm-9 col-9"
                                        variant="inherit"
                                        noWrap
                                    >
                                        {lt.label}
                                    </Typography>
                                </div>
                            )}
                        >
                            {sortingModesElement}
                        </CustomizedSelect>
                    </FormControl>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding row without-side-padding">
                        <CustomizedTextField
                            id={"search"}
                            label={"Recherche par numéro d'OT"}
                            className="full_size col-lg-10 col-md-10 col-sm-10 col-10"
                            value={
                                this.state.searchInput
                                    ? this.state.searchInput
                                    : ""
                            }
                            onChange={this.onSearchInputChange.bind(this)}
                        />
                        <IconButton
                            aria-label="Effacer"
                            className="col-lg-2 col-md-2 col-sm-2 col-2 control-margin-top"
                            onClick={this.clearSearchInput.bind(this)}
                        >
                            <Icon className="red-icon">close</Icon>
                        </IconButton>
                    </div>
                    <FormControlLabel
                        className={
                            "col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top"
                        }
                        control={
                            <Switch
                                value={"valide"}
                                color="secondary"
                                onChange={this.setDisplayEndedInterventions.bind(
                                    this
                                )}
                                checked={
                                    this.props.interventionsFilters
                                        .displayEndedInterventions
                                }
                            />
                        }
                        label={
                            this.props.interventionsFilters
                                .displayEndedInterventions
                                ? "Toutes"
                                : "Non terminées"
                        }
                    ></FormControlLabel>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedDisplayMode: (value, interventionsFilters) =>
            dispatch(setSelectedDisplayMode(value, interventionsFilters)),
        setOrderBy: (value, interventionsFilters) =>
            dispatch(setOrderBy(value, interventionsFilters)),
        setDisplayEndedInterventions: (value, interventionsFilters) =>
            dispatch(setDisplayEndedInterventions(value, interventionsFilters)),
        setFilteredAndSortedInterventions: (interventionsFilters) =>
            dispatch(setFilteredAndSortedInterventions(interventionsFilters)),
        searchByInterventionNumber: (input, interventionsFilters) =>
            dispatch(searchByInterventionNumber(input, interventionsFilters)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InterventionsFilters);
